import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/outsourced/dashboard/page.tsx");
